// extracted by mini-css-extract-plugin
export var readonly = "_fb-1";
export var star = "_fb-0";